import { CrudApiService } from './crud-api.service';

export class DoctorApiService extends CrudApiService {
  constructor(http, endpoint, adapter) {
    super(http, endpoint, adapter);
  }

  async getAvalibleDates(uuid, start, end) {
    const response = await this.http.get(
      this.endpoint + uuid + '/free_dates/',
      { start, end }
    );
    const data = response.data;
    const items = data;
    const total = items.length;
    return { items, total };
  }

  async getAvalibleSlotsByDate(uuid, date) {
    const response = await this.http.get(
      this.endpoint + uuid + '/free_slots/' + date
    );
    const data = response.data;
    const items = data;
    const total = items.length;
    return { items, total };
  }

  async getBySpecialty(uuid) {
    const { data } = await this.http.get(
      this.endpoint + 'by_specialty/' + uuid
    );
    const items = data.map(item => ({ ...item, ...this.deserialize(item) }));
    const total = items.length;
    return { items, total };
  }
}
